import { useContext } from 'react';
import ConfirmDialogStateContext from './ConfirmDialogStateContext';

const useConfirmDialog = () => {
  const { showConfirmDialog } = useContext(ConfirmDialogStateContext);
  return {
    showConfirmDialog,
  };
};

export default useConfirmDialog;
